export enum CompanyType {
  INDIVIDUAL = 'individual',
  ORGANIZATION = 'organization',
}

export enum UserGroup {
  EMPLOYEE = 'EMPLOYEE'
}
